var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"courseD flex-layout"},[_c('div',{staticClass:"courseDimg"},[_c('img',{attrs:{"src":_vm.itemData.image}})]),_c('div',{staticClass:"narrate"},[_c('p',[_vm._v("目标：")]),_c('p',[_vm._v(_vm._s(_vm.itemData.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }